import React from 'react';
import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material';

function SecondSection() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Grid item sx={{ background: '#38383b', color: 'white', padding: '20px' }}>
      <Typography
        sx={{
          marginBottom: 3,
          fontSize: isSmallScreen ? '15px' : '18px',
          paddingLeft: isSmallScreen ? '11px' : '20vh',
          paddingRight: isSmallScreen ? '11px' : '20vh',
          paddingTop: '5vh',
          textAlign: 'justify',
          lineHeight: '2.0'
        }}
      >
        {' '}
        "My love for people and honest dentistry is the cornerstone of our practice. We never
        recommend a procedure unless it is required, and always strive to do what is best for the
        patient. A happy patient makes for a happier doctor in my opinion.”{' '}
      </Typography>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          paddingBottom: '5vh'
        }}
      >
        <Typography style={{ fontSize: '18px', marginBottom: '7px' }}>Dr C Jagadeesh</Typography>
        <Typography variant="h5" sx={{ marginTop: '5px', fontSize: '13px' }}>
          Managing Director
        </Typography>
      </div>
    </Grid>
  );
}

export default SecondSection;
